import { memo } from "react";
import { useTranslation } from "react-i18next";
import "./MediaPartner.css";

const BASE = process.env.PUBLIC_URL + "/images/partners";

// --- HIT RADIO logo asset ------------------------------------------------
const LOGO_SRC = `${BASE}/hit-radio.jpeg`;

// Logo is currently non-clickable. To make it a link again, restore the
// <a> wrapper in the JSX below and re-enable this URL.
// const PARTNER_URL = "https://www.hitradio.ma";

/**
 * Media partner attribution.
 *
 * variant:
 *   "footer"   - compact inline mark for the global footer
 *   "homepage" - slightly larger mark for the landing page
 */
const MediaPartner = memo(function MediaPartner({ variant = "footer" }) {
  const { t } = useTranslation();
  const label = t("partners.mediaPartner");

  return (
    <div className={`media-partner media-partner--${variant}`}>
      <span className="media-partner-label">{label}</span>
      {/* Non-clickable logo. To make it a link again, swap this <span>
          back to:
          <a
            className="media-partner-link"
            href={PARTNER_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${label}: HIT RADIO`}
          >
            ...logo...
          </a> */}
      <span className="media-partner-link">
        <img
          className="media-partner-logo"
          src={LOGO_SRC}
          alt="HIT RADIO"
          loading="lazy"
          draggable="false"
        />
      </span>
    </div>
  );
});

export default MediaPartner;
